<template src='./new.pug' lang='pug'></template>

<script>
import { VueTabs, VTab } from 'vue-nav-tabs'
import Draggable from 'vuedraggable'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import ClassificationCriteria from '../../../registration/conciliationPlan/classificationCriteria/ClassificationCriteria'
import NewClassificationCriteria from '../../../registration/conciliationPlan/classificationCriteria/NewClassificationCriteria'
import ConciliationCriteria from '../../../registration/conciliationPlan/conciliationCriteria/ConciliationCriteria'
import NewConciliationCriteria from '../../../registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria'
import idioma from '../../../../../build/language/index'
import customSorter from '../../../../utils/customSorter.js'
import looseDeepEqual from '../../../../utils/looseDeepEqual'
import { maskThousand } from '../../../../utils/numberMasker'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'ConciliationPlanNew',

  components: {
    VueTabs,
    VTab,
    Draggable,
    PageTitle,
    FilterPortlet,
    ButtonPrimary,
    ClassificationCriteria,
    NewClassificationCriteria,
    ConciliationCriteria,
    NewConciliationCriteria
  },

  data () {
    return {
      isManagingClassCriteria: false,
      requestSent: false,
      planName: null,
      planToEdit: null,
      classificationCriterias: [],
      conciliationCriterias: [],
      tabMain: '',
      criteriaToEdit: null,
      defaultCriteria: {
        ativo: true,
        relevante: true,
        criterioEmUso: false,
        classificacaoCampos: [],
        conta: null
      },
      concilCriteriaToEdit: null,
      defaultConcilCriteria: {
        ativo: true,
        criterioEmUso: false,
        conciliacaoCampos: [],
        conta: null,
        banco: null,
        descricao: '',
        estabelecimentos: [],
        diasDiferencaMin: 0,
        diasDiferencaMax: 0,
        valorDiferencaMax: 0.00,
        valorDivergenciaMax: 0.00,
        motivoOcorrencia: null
      },
      idsCriteriasRemoved: [],
      categories: [],
      febraban: [],
      banks: [],
      accounts: [],
      attributesCfgClassif: [],
      attributesCfg: [],
      conciliationFields: [],
      conciliationFieldsBanking: [], // apenas tipo = 'B'
      occurrenceReasons: [],
      isManagingConcilCriteria: false,
      idioma: idioma,
      idsConciliationCriteriasRemoved: [],
      errorCaptured: false
    }
  },

  computed: {
    planToEditId () {
      return this.$store.getters.planToEditId
    },
    portletTitle () {
      if (this.planToEditId) {
        return this.$t('planoConciliacao.titulos.editarPlanoConciliacao')
      } else {
        return this.$t('planoConciliacao.titulos.novoPlanoConciliacao')
      }
    },
    tabClass () {
      return this.$t('planoConciliacao.labels.criteriosClassificacao')
    },
    tabConcil () {
      return this.$t('planoConciliacao.labels.criteriosConciliacao')
    }
  },

  watch: {
    planName: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject,
          {
            id: this.planToEditId,
            nome: this.planName,
            criteriosClassificacao: this.classificationCriterias,
            criteriosConciliacao: this.conciliationCriterias
          }
        ))
      },
      deep: true
    }
  },

  methods: {
    savePlan () {
      this.classificationCriterias.map(criteria => {
        if (criteria.classificacaoCampos.length > 0) {
          criteria.classificacaoCampos.map(classif => {
            classif.idAtributoCfg = classif.idAtributoCfg && classif.idAtributoCfg.id ? classif.idAtributoCfg.id : classif.idAtributoCfg
            classif.nomeAtributo = classif.nomeAtributo && classif.nomeAtributo.id ? classif.nomeAtributo.id : classif.nomeAtributo
          })
        }
      })
      this.conciliationCriterias.map(criteria => {
        if (criteria.valorDiferencaMax && (typeof criteria.valorDiferencaMax === 'string')) {
          criteria.valorDiferencaMax = parseFloat(this.removeMonetaryMask(criteria.valorDiferencaMax))
        }

        if (criteria.valorDivergenciaMax && (typeof criteria.valorDivergenciaMax === 'string')) {
          criteria.valorDivergenciaMax = parseFloat(this.removeMonetaryMask(criteria.valorDivergenciaMax))
        }
        if (criteria.conciliacaoCampos.length > 0) {
          criteria.conciliacaoCampos.map(field => {
            // Caso o objeto 'atributo' exista e não seja vazio, normaliza campos
            if (field.atributo && Object.keys(field.atributo).length > 0 && field.atributo.constructor === Object) {
              field.atributo.atributoCfg = { id: field.atributo.atributoCfg && field.atributo.atributoCfg.id ? field.atributo.atributoCfg.id : field.atributo.atributoCfg }
              field.atributo.nomeAtributo = field.atributo.nomeAtributo && field.atributo.nomeAtributo.id ? field.atributo.nomeAtributo.id : field.atributo.nomeAtributo
            }
            // Caso o objeto 'banco' exista e não seja vazio, normaliza campos
            if (field.banco && Object.keys(field.banco).length > 0 && field.banco.constructor === Object) {
              criteria.banco = field.banco
            }
            // Caso o objeto 'conta' exista e não seja vazio, normaliza campos
            if (field.conta && Object.keys(field.conta).length > 0 && field.conta.constructor === Object) {
              criteria.conta = field.conta
            }
          })
        }
      })

      const plan = {
        nome: this.planName,
        criteriosClassificacao: this.classificationCriterias,
        criteriosConciliacao: this.conciliationCriterias,
        idsCriteriosClassificacaoRemovidos: this.idsCriteriasRemoved,
        idsCriteriosConciliacaoRemovidos: this.idsConciliationCriteriasRemoved
      }

      if (this.planToEditId != null) {
        plan.id = this.planToEditId
      }
      this.requestSent = true
      this.$store.dispatch('savePlan', plan).then((response) => {
        this.$root.$refs.notification.success(response.data.message)
        this.$store.dispatch('setHasUnsavedChanges', false)
        this.$router.push(PATHS.LIST_CONCILIATION_PLANS)
      }).catch((error) => {
        this.$root.$refs.notification.error(error.message)
      })
      .finally(() => {
        this.requestSent = false
      })
    },

    loadPlan () {
      let self = this
      this.$store.dispatch('getPlan', this.planToEditId).then((response) => {
        self.planToEdit = response.data.data[0]
        self.planName = self.planToEdit.nome
        self.classificationCriterias = self.planToEdit.criteriosClassificacao.sort((a, b) => Number(a.ordem) - Number(b.ordem))
        self.classificationCriterias.map(crit => {
          crit.classificacaoCampos.map(field => {
            field.key = field.id
          })
        })

        self.conciliationCriterias = self.planToEdit.criteriosConciliacao.sort((a, b) => Number(a.ordem) - Number(b.ordem))
        self.conciliationCriterias.map(crit => {
          crit.conciliacaoCampos.map(field => {
            field.key = field.id
          })

          if (crit.valorDivergenciaMax !== null && crit.valorDivergenciaMax !== undefined) {
            crit.valorDivergenciaMax = self.idioma.getMoneyMaskByLanguage().prefix + '' + maskThousand(crit.valorDivergenciaMax)
          } else {
            crit.valorDivergenciaMax = ''
          }

          if (crit.valorDiferencaMax !== null && crit.valorDiferencaMax !== undefined) {
            crit.valorDiferencaMax = self.idioma.getMoneyMaskByLanguage().prefix + '' + maskThousand(crit.valorDiferencaMax)
          } else {
            crit.valorDiferencaMax = ''
          }
          if (crit.banco) {
            crit.banco.label = (crit.banco.codigo ? crit.banco.codigo + '-' : '') + crit.banco.nomeFantasia
          }

          if (crit.conta) {
            crit.conta.label = crit.conta.id !== 0 ? (crit.conta.nome + ' (' +
              crit.conta.numAgencia + (crit.conta.digAgencia ? ('-' + crit.conta.digAgencia) : '') +
              '/' +
              crit.conta.conta + (crit.conta.digConta ? ('-' + crit.conta.digConta) : '') +
              ')' +
              (crit.conta.ativo === undefined || crit.conta.ativo === null || crit.conta.ativo ? '' : (' [' + this.$t('contaBancaria.labels.inativa') + ']')))
              : crit.$t('planoConciliacao.labels.nenhumItem')
          }
        })

        self.defaultObject = {
          id: self.planToEditId,
          nome: self.planName,
          criteriosClassificacao: self.classificationCriterias,
          criteriosConciliacao: self.conciliationCriterias
        }
        if (self.classificationCriterias && self.classificationCriterias.length > 0) {
          self.updateCriteriasAttCfg()
          self.updateCriteriasConcFields()
        }
        if (self.conciliationCriterias && self.conciliationCriterias.length > 0) {
          self.updateConcilCriteriasAttCfg()
        }
      }).catch((error) => {
        self.$root.$refs.notification.error(error.message)
      })
    },

    validate (event) {
      event.preventDefault()
      this.changeClassifOrder()
      this.changeConcilOrder()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.savePlan()
        } else {
          this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'planoConciliacao.erro.salvar')
        }
      })
    },

    back () {
      this.$router.push(PATHS.LIST_CONCILIATION_PLANS)
    },

    createOrEditCriteria (criteria = {}) {
      if (!criteria || !criteria.ordem) {
        criteria = {...this.defaultCriteria, classificacaoCampos: [...this.defaultCriteria.classificacaoCampos]}
      }

      this.criteriaToEdit = {...criteria, classificacaoCampos: [...criteria.classificacaoCampos]}
      this.isManagingClassCriteria = !this.isManagingClassCriteria
    },

    updateCriteriasList (criteria = {}) {
      if (this.classificationCriterias == null) {
        this.classificationCriterias = []
      }

      this.checkDescriptionExistsCriteria(criteria)

      if (criteria.idCriterioClassificacao || criteria.ordem) {
        const index = this.classificationCriterias.findIndex(crit => {
          return crit.idCriterioClassificacao
            ? (crit.idCriterioClassificacao === criteria.idCriterioClassificacao)
            : (crit.ordem === criteria.ordem)
        })

        if (index === -1) {
          throw new Error('Not found')
        }
        this.classificationCriterias.splice(index, 1, criteria)
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAlterado')
      } else {
        criteria.planoConciliacao = this.planToEditId
        criteria.ordem = this.classificationCriterias.length + 1
        this.classificationCriterias.push(criteria)
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAdicionado')
      }

      this.criteriaToEdit = {...this.defaultCriteria, classificacaoCampos: [...this.defaultCriteria.classificacaoCampos]}
    },

    checkDescriptionExistsCriteria (criteria = {}) {
      const existsDescriptionCriteria = this.classificationCriterias.find(crit => crit.descricao === criteria.descricao && crit.ordem !== criteria.ordem)

      if (existsDescriptionCriteria) {
        this.errorCaptured = true
        this.$root.$refs.notification.warning('planoConciliacao.validacao.criterioNomeRepetido')
        throw new Error('There is already a criterion with this description')
      }
    },

    removeCriteriaHandler (criteria = {}) {
      const index = this.classificationCriterias.findIndex(crit => crit === criteria)
      this.classificationCriterias.splice(index, 1)
      if (criteria.idCriterioClassificacao) {
        this.idsCriteriasRemoved.push(criteria.idCriterioClassificacao)
      }
    },

    updateCriteriasAttCfg () {
      this.classificationCriterias.map(crit => {
        crit.classificacaoCampos.map(field => {
          field.idAtributoCfg = this.attributesCfgClassif.find(cfg => cfg.id === field.idAtributoCfg.toString())
          setTimeout(() => {
            if (field.idAtributoCfg && field.idAtributoCfg.children && field.idAtributoCfg.children.length > 0) {
              field.nomeAtributo = field.idAtributoCfg.children.find(att => att.id === field.nomeAtributo)
            }
          }, 250)
        })
      })
    },

    updateConcilCriteriasAttCfg () {
      let self = this
      this.conciliationCriterias.map(crit => {
        crit.conciliacaoCampos.map(field => {
          if (field.atributo && field.atributo instanceof Object && field.atributo.atributoCfg && field.atributo.atributoCfg instanceof Object) {
            field.atributo.atributoCfg = self.attributesCfg.find(cfg => cfg.id.toString() === (field.atributo.atributoCfg ? field.atributo.atributoCfg.id : field.atributo.atributoCfg).toString())
            setTimeout(() => {
              if (field.atributo.atributoCfg && field.atributo.atributoCfg.children && field.atributo.atributoCfg.children.length > 0) {
                field.atributo.nomeAtributo = field.atributo.atributoCfg.children.find(att => att.id === field.atributo.nomeAtributo)
              }
            }, 250)
          } else if (field.atributo && field.atributo instanceof String) {
            self.attributesCfg.map(cfg => {
              if (cfg.linkType === (field.conciliacaoCampoMovFinan ? field.conciliacaoCampoMovFinan.tipoVinculo : null)) {
                cfg.children.map(att => {
                  if (field.atributo === att.id) {
                    field.atributo.atributoCfg = cfg
                    field.atributo.nomeAtributo = att
                  }
                })
              }
            })
          }
        })
      })
    },

    updateCriteriasConcFields () {
      let self = this
      self.classificationCriterias.map(crit => {
        crit.classificacaoCampos.map(field => {
          field.conciliacaoCampo = self.conciliationFieldsBanking.find(concField => {
            if (field.conciliacaoCampo) {
              return concField.id.toString() === field.conciliacaoCampo.id.toString()
            }
            return false
          })
        })
      })
    },

    changeManagingClassCriteria () {
      if (!this.errorCaptured) {
        this.accounts = [...this.accounts]
        this.criteriaToEdit = null
        this.isManagingClassCriteria = !this.isManagingClassCriteria
      }
      this.errorCaptured = false
    },

    changeClassifOrder () {
      this.classificationCriterias.map(crit => {
        crit.ordem = this.classificationCriterias.findIndex(item => looseDeepEqual(item, crit)) + 1
      })
    },

    changeConcilOrder () {
      this.conciliationCriterias.map(crit => {
        crit.ordem = this.conciliationCriterias.findIndex(item => looseDeepEqual(item, crit)) + 1
      })
    },

    loadCategories () {
      this.$store.dispatch('getCategories', {
        url: '/conciliationPlan/loadCategories',
        flTipoCategoria: null,
        validarUso: false
      }).then((response) => {
        let catArray = []
        response.data.forEach(cat => {
          cat.label = cat.numero + ' - ' + cat.nome
          catArray.push(cat)
        })
        // arrayDottedSorter ordena o array baseado em valores do tipo '1.1.1'
        this.categories = customSorter.arrayDottedSorter(catArray, 'numero', 'asc')
      }).catch((error) => {
        this.$root.$refs.notification.error(error.data.message)
      })
    },

    loadFebraban () {
      this.$store.dispatch('getFebraban')
      .then((response) => {
        this.febraban = response.data.data
        this.febraban.forEach(cat => {
          cat.label = cat.codigo + ' - ' + cat.descricao
        })
        this.febraban.sort((a, b) => Number(a.codigo) - Number(b.codigo))
      })
    },

    loadBanks () {
      this.$store.dispatch('getBanks')
      .then((response) => {
        this.banks = response.data.data
        this.banks.forEach(bank => {
          bank.label = (bank.codigo ? bank.codigo + '-' : '') + bank.nomeFantasia
        })
        this.banks.sort((a, b) => Number(a.codigo) - Number(b.codigo))
      })
    },

    loadBankAccounts () {
      let url = '/bankAccounts/'
      this.$store.dispatch('getBankAccounts', url)
        .then((response) => {
          this.accounts = response.data.data
          this.accounts.forEach(account => {
            account.label = account.id !== 0 ? (account.nome + ' (' +
              account.numAgencia + (account.digAgencia ? ('-' + account.digAgencia) : '') +
              '/' +
              account.conta + (account.digConta ? ('-' + account.digConta) : '') +
              ')' +
              (account.ativo === undefined || account.ativo === null || account.ativo === true ? '' : (' [' + this.$t('contaBancaria.labels.inativa') + ']')))
              : this.$t('planoConciliacao.labels.nenhumItem')
          })
          this.accounts.sort((a, b) => Number(a.id) - Number(b.id))
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
    },

    loadConciliationFieldsData () {
      this.$store.dispatch('getAttributesSet').then((attributesSetList) => {
        // somente conjuntos com atributos cadastrados
        this.attributesCfg = attributesSetList
        this.attributesCfgClassif = attributesSetList.filter(set => (set.children && set.children.length > 0) && (set.linkType === 'E'))
      }).then(() => {
        this.$store.dispatch('getConciliationFields')
        .then((response) => {
          // apenas campos de movimentacao bancaria
          this.conciliationFields = response.data.data
          this.conciliationFieldsBanking = response.data.data.filter(field => field.tipo && field.tipo === 'B')
          this.conciliationFieldsBanking.forEach(cfg => {
            cfg.label = cfg.nome + ' | ' + cfg.expressao
          })
        })
      }).then(() => {
        if (this.planToEditId) {
          this.loadPlan()
        } else {
          this.defaultObject = {
            id: this.planToEditId,
            nome: this.planName,
            criteriosClassificacao: this.classificationCriterias,
            criteriosConciliacao: this.conciliationCriterias
          }
        }
      }).catch((error) => {
        this.$root.$refs.notification.error(error.message)
      })
    },

    createOrEditConcilCriteria (criteria = {}) {
      if (!criteria || !criteria.ordem) {
        criteria = {...this.defaultConcilCriteria, conciliacaoCampos: [...this.defaultConcilCriteria.conciliacaoCampos]}
      }

      this.concilCriteriaToEdit = {...criteria, conciliacaoCampos: [...criteria.conciliacaoCampos]}
      this.isManagingConcilCriteria = !this.isManagingConcilCriteria
    },

    removeConcilCriteriaHandler (criteria = {}) {
      const index = this.conciliationCriterias.findIndex(crit => crit === criteria)
      this.conciliationCriterias.splice(index, 1)
      if (criteria.id) {
        this.idsConciliationCriteriasRemoved.push(criteria.id)
      }
    },

    loadOccurrences () {
      let url = 'conciliationPlan/occurrenceReason/list'
      this.$store.dispatch('getOccurrenceReasons', url)
      .then((response) => {
        this.occurrenceReasons = response.data.data
      })
      .catch((error) => {
        this.$root.$refs.notification.error(error.message)
      })
    },

    updateConcilCriteriasList (criteria = {}) {
      if (this.conciliationCriterias == null) {
        this.conciliationCriterias = []
      }

      this.checkDescriptionExistsConcilCriteria(criteria)

      if (criteria.id || criteria.ordem) {
        const index = this.conciliationCriterias.findIndex(crit => {
          return crit.id
            ? (crit.id === criteria.id)
            : (crit.ordem === criteria.ordem)
        })

        if (index === -1) {
          throw new Error('Not found')
        }
        this.conciliationCriterias.splice(index, 1, criteria)
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAlterado')
      } else {
        criteria.planoConciliacao = this.planToEditId
        criteria.ordem = this.conciliationCriterias.length + 1
        this.conciliationCriterias.push(criteria)
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAdicionado')
      }

      this.concilCriteriaToEdit = {...this.defaultConcilCriteria, conciliacaoCampos: [...this.defaultConcilCriteria.conciliacaoCampos]}
    },

    checkDescriptionExistsConcilCriteria (criteria = {}) {
      const existsDescriptionCriteria = this.conciliationCriterias.find(crit => crit.descricao === criteria.descricao && crit.ordem !== criteria.ordem)

      if (existsDescriptionCriteria) {
        this.errorCaptured = true
        this.$root.$refs.notification.warning('planoConciliacao.validacao.criterioConcilNomeRepetido')
        throw new Error('There is already a criterion with this description')
      }
    },

    changeManagingConcilCriteria () {
      if (!this.errorCaptured) {
        this.concilCriteriaToEdit = null
        this.isManagingConcilCriteria = !this.isManagingConcilCriteria
      }
      this.errorCaptured = false
    },

    removeMonetaryMask (value) {
      let splittedStartBalance = value.toString().split(' ')

      if (splittedStartBalance.length > 1) {
        return splittedStartBalance[1].replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1')
      }
      return value.replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1')
    }
  },

  created () {
    this.loadOccurrences()
    this.loadCategories()
    this.loadBanks()
    this.loadBankAccounts()
    this.loadFebraban()
    this.loadConciliationFieldsData()
  },

  beforeDestroy () {
    this.$store.dispatch('setHasUnsavedChanges', false)
    this.$store.dispatch('cleanPlanToEdit')
  }
}
</script>

<style scoped>
.categories-header {
  margin-bottom: 0;
}

.categories-header>div {
  text-align: center;
}

.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
  transition: all .2s;
}

.check-group {
  margin-left: 10px
}

.concil-criterias-header-acoes-tit {
  width: 8.5vw;
  text-align: right;
  padding: 0px 5px 0px 0px;
}

.criterias-header-acoes-tit {
  width: 5vw;
  text-align: right;
  padding: 0px 5px 0px 0px;
}

.crit-font-sized {
  font-size: 1.06vh;
}
</style>



// WEBPACK FOOTER //
// New.vue?5483fdfc